const generateFacilitySlide = (url) => {
	const slide = document.createElement('div');
	slide.setAttribute('class', 'swiper-slide');
	slide.setAttribute(
		'style',
		`background-image: url(${url})`,
	);

	return slide;
};

export default generateFacilitySlide;



// WEBPACK FOOTER //
// ./src/js/index/generateFacilitySlide.js